import { api } from "./api";
import { notifyError } from "./error";
import * as NotificationActions from "./notification";

export const getEntries = (event_division_id) => (dispatch) =>
    api.get(`event_divisions/${event_division_id}/entries`).then((res) =>
        dispatch({
            type: "SET_EVENT_DIVISION_ENTRIES",
            event_division_id,
            res,
        }),
    );

export const denyEntry =
    (event_division_id, entry_id, isDivisionTeamType) => (dispatch) =>
        api.delete(`entries/${entry_id}/deny`).then(
            () => {
                dispatch(
                    NotificationActions.success(
                        "Entry has been moved to the cancellation list 💃",
                    ),
                );
                return dispatch(getEntries(event_division_id));
            },
            (e) => {
                dispatch(getEntries(event_division_id));
                notifyError(dispatch)(e);
            },
        );

export const confirmEntry = (event_division_id, entry_id) => (dispatch) =>
    api.put(`entries/${entry_id}/confirm`).then(
        () => dispatch(getEntries(event_division_id)),
        (e) => {
            dispatch(getEntries(event_division_id));
            throw e;
        },
    );

export const confirmAndCancelPayment =
    (event_division_id, entry_id) => (dispatch) =>
        api.put(`entries/${entry_id}/confirm_and_cancel_payment`).then(
            () => dispatch(getEntries(event_division_id)),
            (e) => {
                dispatch(getEntries(event_division_id));
                throw e;
            },
        );

export const confirmAndRequestPayment =
    (event_division_id, entry_id) => (dispatch) =>
        api.put(`entries/${entry_id}/confirm_and_request_payment`).then(
            () => dispatch(getEntries(event_division_id)),
            (e) => {
                dispatch(getEntries(event_division_id));
                throw e;
            },
        );

export const cancelPayment = (event_division_id, entry_id) => (dispatch) =>
    api.put(`entries/${entry_id}/cancel_payment`).then(
        () => dispatch(getEntries(event_division_id)),
        (e) => {
            dispatch(getEntries(event_division_id));
            throw e;
        },
    );

export const confirmEntries = (event_division_id, entries) => (dispatch) =>
    api
        .put("entries/confirm_entries", {
            ids: entries.map((entry) => entry.id),
        })
        .then((r) => {
            dispatch(getEntries(event_division_id));
            return r;
        })
        .catch((e) => {
            dispatch(getEntries(event_division_id));
            throw e;
        });

export const deleteEntry = (event_division_id, entry_id) => (dispatch) =>
    api.delete(`entries/${entry_id}`).then(
        () => dispatch(getEntries(event_division_id)),
        (e) => {
            dispatch(getEntries(event_division_id));
            notifyError(dispatch)(e);
        },
    );

export const updateEntry =
    (event_division_id, entry_id, entry, limit = 5) =>
    (dispatch) =>
        api.put(`entries/${entry_id}`, { entry }, limit).then(
            (res) =>
                dispatch({
                    type: "SET_ENTRY",
                    event_division_id,
                    entry_id,
                    entry,
                    res,
                }),
            (e) => {
                dispatch(getEntries(event_division_id));
                notifyError(dispatch)(e);
            },
        );

export const createEntries =
    (event_division_id, entries, isDivisionTeamType) => (dispatch) =>
        api
            .post(`event_divisions/${event_division_id}/entries`, { entries })
            .then((res) =>
                dispatch({
                    type: "SET_EVENT_DIVISION_ENTRIES",
                    event_division_id,
                    res,
                }),
            )
            .then(() =>
                dispatch(
                    NotificationActions.success(
                        `Woop! ${isDivisionTeamType ? "Teams" : "Athletes"} successfully added`,
                    ),
                ),
            );

export const uploadEntries =
    (event_division_id, file, overwrite, isDivisionTeamType) => (dispatch) => {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("overwrite", overwrite);

        return api
            .postFile(
                `event_divisions/${event_division_id}/entries/upload`,
                formData,
            )
            .then(
                () => dispatch(getEntries(event_division_id)),
                (e) => {
                    dispatch(getEntries(event_division_id));
                    notifyError(dispatch)(e);
                },
            )
            .then(() =>
                dispatch(
                    NotificationActions.success(
                        isDivisionTeamType
                            ? "Excellent! Teams successfully added to this division."
                            : "Excellent! Athletes successfully added to this division.",
                    ),
                ),
            );
    };
